export default __webpack_public_path__ + "static/media/switch-horizontal.e5b66116.svg";